import { defineComponent as _defineComponent } from 'vue'
import { PropType } from "vue";
import { IBookInfo } from "@/domain/entities/book";
import { computed } from "@vue/reactivity";
import { BookIntervalCode } from "@/types";
import useGetLineRouteName from "@/use/useGetLineRouteName";
import dayjs from "dayjs";
import "dayjs/locale/ko";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import LineTypeChip from "../shared/chip/LineTypeChip.vue";


const __default__ = {
  name: "BookHistoryInfo",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  bookInfo: {
    type: Object as PropType<IBookInfo>,
    required: true,
  },
  isCanceled: {
    type: Boolean,
    default: false,
  },
},
  emits: ["onClickBusStopLocation"],
  setup(__props, { expose: __expose }) {
  __expose();

const props = __props;



dayjs.locale("ko");
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault("Asia/Seoul");

const boardDateTitle = computed(() =>
  props.bookInfo.bookIntervalCode === BookIntervalCode.MONTH
    ? "탑승월"
    : "탑승일"
);
const boardDateText = computed(() =>
  props.bookInfo.bookIntervalCode === BookIntervalCode.MONTH
    ? dayjs(props.bookInfo.boardDate).format("YYYY-MM")
    : dayjs(props.bookInfo.boardDate).format("YYYY-MM-DD(dd)")
);

const __returned__ = { props, boardDateTitle, boardDateText, get useGetLineRouteName() { return useGetLineRouteName }, LineTypeChip }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})